<template>
  <v-navigation-drawer
    class="menu rounded"
    floating
    v-model="$store.state.drawer"
    right
    :mini-variant.sync="$store.state.mini"
    :app="$store.state.break_point <= 991"
    :style="{
      height:
        $store.state.break_point <= 991 ? '100%!important' : 'auto!important',
    }"
  >
    <v-list-item class="px-2">
      <v-list-item-avatar>
        <v-img src="https://randomuser.me/api/portraits/men/85.jpg"></v-img>
      </v-list-item-avatar>
      <v-list-item-title
        >{{
          $store.state.restline ? $store.state.restline.name : "Super Admin"
        }}
      </v-list-item-title>

      <v-btn
        color="grey lighten-3"
        fab
        x-small
        depressed
        v-if="$store.state.break_point > 991"
        @click.stop="$store.state.mini = !$store.state.mini"
      >
        <v-icon>chevron_right</v-icon>
      </v-btn>
    </v-list-item>
    <v-divider></v-divider>

    <div>
      <v-list dense>
        <v-list-item
          active-class="primary white--text"
          v-for="(item, x) in links"
          :key="x"
          link
          :to="{ name: item.link }"
        >
          <v-list-item-icon class="me-2">
            <v-icon style="font-size: 18px">{{ item.icon }}</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">{{
              item.title
            }}</v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item active-class="primary white--text" @click="logout()">
          <v-list-item-icon class="me-2">
            <v-icon style="font-size: 18px">logout</v-icon>
          </v-list-item-icon>

          <v-list-item-content>
            <v-list-item-title class="font-weight-bold">
              {{ trans("menu", "logout") }}
            </v-list-item-title>
          </v-list-item-content>
        </v-list-item>
      </v-list>
    </div>
  </v-navigation-drawer>
</template>
<script>
export default {
  data() {
    return {
      drawer: true,

      mini: false,
    };
  },
  computed: {
    routes() {
      return [
        {
          title: this.trans("menu", "dashboard"),
          icon: "home",
          link: "dashboard",
          role: ["superAdmin"],
        },
        {
          title: this.trans("menu", "orders"),
          icon: "local_mall",
          link: "orders",

          role: ["superAdmin", "admin"],
        },
        {
          title: this.trans("menu", "productsOrders"),
          icon: "shopping_cart",
          link: "productsOrders",

          role: ["superAdmin"],
        },

        {
          title: this.trans("menu", "services"),
          icon: "cleaning_services",
          link: "services",

          role: ["superAdmin"],
        },
        {
          title: this.trans("menu", "categories"),
          icon: "category",
          link: "categories",

          role: ["superAdmin"],
        },
        {
          title: this.trans("menu", "products"),
          icon: "inventory_2",
          link: "products",

          role: ["superAdmin", "admin"],
        },
        {
          title: this.trans("menu", "countries"),
          icon: "location_city",
          link: "countries",

          role: ["superAdmin"],
        },
        {
          title: this.trans("menu", "banners"),
          icon: "collections_bookmark",
          link: "banners",

          role: ["superAdmin"],
        },
        {
          title: this.trans("menu", "coupons"),
          icon: "real_estate_agent",
          link: "coupons",

          role: ["superAdmin"],
        },
        {
          title: this.trans("menu", "pages"),
          icon: "article",
          link: "pages",

          role: ["superAdmin"],
        },
        {
          title: this.trans("menu", "workers"),
          icon: "engineering",
          link: "workers",

          role: ["superAdmin", "admin"],
        },
        {
          title: this.trans("menu", "customers"),
          icon: "group",
          link: "customers",
          super: false,
          role: ["superAdmin"],
        },
        {
          title: this.trans("menu", "settings"),

          icon: "settings",
          link: "settings",
          super: false,
          role: ["superAdmin"],
        },
      ];
    },
    links() {
      let links = [];
      const role = this.$store.getters.role;
      this.routes.forEach((e) => {
        if (e.role.includes(role)) {
          links.push(e);
        }
      });
      return links;
    },
  },
  methods: {
    logout() {
      let vm = this;
      this.$store.commit("logout");
      setTimeout(() => {
        vm.$router.push({ name: "login" });
      }, 500);
    },
  },
};
</script>

<style lang="scss">
.menu {
  // min-width: 245px;
  height: calc(100vh - 150px) !important;
  min-height: calc(100vh - 150px) !important;
  @media (max-width: 991px) {
    height: 100vh !important;
    min-height: 100vh !important;
  }
  max-height: calc(100vh - 200px) !important;
  box-shadow: 0px 3px 1px -5px rgb(0 0 0 / 12%), 0px 2px 4px 0px rgb(0 0 0 / 0%),
    0px 1px 10px 0px rgb(0 0 0 / 12%);
}
</style>
